import { render, staticRenderFns } from "./PhotoDetail.vue?vue&type=template&id=10062f3e&scoped=true"
import script from "./PhotoDetail.vue?vue&type=script&lang=js"
export * from "./PhotoDetail.vue?vue&type=script&lang=js"
import style0 from "./PhotoDetail.vue?vue&type=style&index=0&id=10062f3e&prod&lang=scss&scoped=true"
import style1 from "./PhotoDetail.vue?vue&type=style&index=1&id=10062f3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10062f3e",
  null
  
)

export default component.exports